var sizeMap = {
  sm: 'small',
  md: 'medium',
  lg: 'large',
  xl: 'xlarge',
  xxl: 'xxlarge',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  xxlarge: 'xxlarge',
  circular: 'max',
  pill: 'max'
};
export function normalizeSize(size) {
  return sizeMap[size];
}
function normalizeSpacing(spacerStep) {
  if (spacerStep === 0) return 'base';
  var prefix = spacerStep < 0 ? 'minus' : 'plus';
  var step = Math.abs(spacerStep);
  return "".concat(prefix, "-").concat(step);
}
/**
 * Get a CSS value that can be used when authoring CSS spacer rules
 * @deprecated in favor of cssSpacing
 * @param spacerStep- a spacer step number value (eg -5, 0, 6)
 * @param [fallbackSpacer] - a valid CSS <spacer> token as fallback
 * @returns a string in the form of var(--encore-spacing-variable, <fallback>)
 */
export function cssSpacerValue(spacerStep, fallbackSpacer) {
  var newSpacer = normalizeSpacing(spacerStep);
  return cssSpacing(newSpacer, fallbackSpacer);
}

/**
 * Get a CSS value that can be used when authoring CSS spacer rules
 * @param spacer - a spacer value name (eg minus-5 through 1, base, plus-1 through 6)
 * @param [fallbackSpacer] - a valid CSS <spacer> token as fallback
 * @returns a string in the form of var(--encore-spacing-variable, <fallback>)
 */
export function cssSpacing(spacer, fallbackSpacer) {
  return "var(--encore-spacing-".concat(spacer, ", ").concat(fallbackSpacer, ")");
}

/**
 * Get a CSS value that can be used when authoring CSS border radius rules
 * @param size - a border radius size string(sm, md, lg, xl, xxl)
 * @param [fallback] - a valid CSS pixel value as fallback
 * @returns a string in the form of `var(--border-radius-variable, <fallback>)`
 */
export function cssBorderRadius(size, fallback) {
  return "var(--encore-border-radius-".concat(size, ", ").concat(fallback, ")");
}

/**
 * Get a CSS value that can be used when authoring CSS border width rules
 * @param size - a border width size string(hairline, thin, thick, thicker, focus)
 * @param [fallback] - a valid CSS pixel value as fallback
 * @returns a string in the form of `var(--border-width-variable, <fallback>)`
 */
export function cssBorderWidth(size, fallback) {
  return "var(--encore-border-width-".concat(size, ", ").concat(fallback, ")");
}

/**
 * Get a CSS value that can be used when authoring CSS control size rules
 * @param size - a border radius size string(sm, md, lg)
 * @param [fallback] - a valid CSS pixel value as fallback
 * @returns a string in the form of `var(--control-size-variable, <fallback>)`
 */
export function cssControlSize(size, fallback) {
  return "var(--encore-control-size-".concat(size, ", ").concat(fallback, ")");
}

/**
 * Get a CSS value that can be used when authoring CSS layout margins
 * @param size - a layout margin size string(compact, regular, generous)
 * @param [fallback] - a valid CSS pixel value as fallback
 * @param [isNegative] - a boolean for if this is a negative margin
 * @returns a string in the form of `var(--layout-margin-variable, <fallback>)`
 */
export function cssLayoutMargin(size, fallback, isNegative) {
  if (isNegative) {
    return "calc(-1 * var(--encore-layout-margin-".concat(size, ", ").concat(fallback, "))");
  }
  return "var(--encore-layout-margin-".concat(size, ", ").concat(fallback, ")");
}